import { Component, OnInit, Input, inject, ViewChild, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { DatePipe } from '@angular/common';
import { jqxTextAreaComponent } from 'jqwidgets-ng/jqxtextarea';
import { OrderStatusUpdateDto } from 'src/app/models/apiRequestModels';
import { NgxSpinnerService } from 'ngx-spinner';
import { jqxNotificationComponent } from 'jqwidgets-ng/jqxnotification';
import Swal from 'sweetalert2';
import { OpenSearchServerless } from 'aws-sdk';
import { Observable, of, throwError, zip } from 'rxjs';
import { catchError, map, startWith, tap, timeout } from 'rxjs/operators';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.css'],
  providers: [DatePipe]
})
export class OrderStatusComponent implements OnInit {
  @Input() dataFromParent: any;
  @ViewChild('notesComponent', { static: false }) notesComponent: jqxTextAreaComponent;
  @ViewChild('msgNotification', { static: false }) msgNotification: jqxNotificationComponent;
  @Output() notify = new EventEmitter<Promise<string>>();

  constructor(private backendService: BackendService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe) { }
  orderStatuses: any = [];
  orderResponse: any = [];
  currentStatus: string;
  lastModifiedDate: string;
  defaultSelectedDate: Date;
  SelectedDate: Date;
  today: Date;
  isEditing = false;
  notesText: string = '';
  orderStatusesOptions: any = [];
  emptyText: string = '';
  //textAreaValue: string = '';
  textAreaValueMap: { [statusId: number]: string } = {};
  isEditableValueMap: { [statusId: number]: boolean } = {};

  ngOnInit(): void {
    this.today = new Date();
    this.loadgetorderstatuses();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataFromParent'] && changes['dataFromParent'].currentValue) {
      this.orderResponse = this.dataFromParent;
      this.loadData();
      if (this.orderStatuses != null) {
        this.orderStatuses.forEach(order => {
          this.textAreaValueMap[order.statusId] = order.notes || '';
          this.isEditableValueMap[order.statusId] = false;
        });
      }
    }
  }
  loadData() {
    if (this.orderResponse.statusHistory != null) {
      this.orderResponse.statusHistory.forEach((item: any) => {
        item.createdTime = item.createdTime !== undefined ? this.convertToLocalFormat(item.createdTime) : item.createdTime;
      });
    }
    this.orderStatuses = this.orderResponse.statusHistory;
    const date = new Date(this.orderResponse);
    this.lastModifiedDate = this.orderResponse.lastStatusUpdate !== undefined ? this.convertToLocalFormat(this.orderResponse.lastStatusUpdate) : this.orderResponse.lastStatusUpdate;
    if (this.orderResponse.lastStatus != null)
      this.currentStatus = this.orderResponse.lastStatus.displayName;
    this.defaultSelectedDate = new Date();
    console.log("this.orderresponse ::: ", this.orderResponse);
    this.spinner.hide();
  }
  rejectOrder() {
    console.log("rejectOrder ... ");
    this.sweetAlert();

  }
  cancel() {
    this.notesComponent.val("");
    this.getOrderDetails();
  }
  updateOrder(data) {
    console.log("Data :;:", data);
    const updatedNote = this.textAreaValueMap[data.statusId];
    if (data.isCompleted) {
      this.notesText = updatedNote;
    } else {
      this.emptyText = updatedNote;
    }
    this.spinner.show()
    var orderStatusUpdateDto = new OrderStatusUpdateDto();
    orderStatusUpdateDto.statusId = data.statusId;
    orderStatusUpdateDto.notes = (data.isCompleted) ? this.notesText : this.emptyText;
    orderStatusUpdateDto.statusHistoryId = data.statusHistoryId == null ? 0 : data.statusHistoryId;
    orderStatusUpdateDto.status = data.status;
    this.updateDetails(orderStatusUpdateDto, false);

  }
   updateDetails(orderStatusUpdateDto, isReject) {
    this.backendService.updateOrderStatus(this.orderResponse.orderId, orderStatusUpdateDto).subscribe(
      res => {
        const updateOrderStatusres = this.backendService.getJSONResponse(res);
        if (updateOrderStatusres.success == false) {
          this.sendNotification(updateOrderStatusres.message, 'error');
        }
        else {
          if (isReject && this.orderResponse.nscJobId != null ) {
            Swal.fire("Order rejected successfully. Please remove the relevant job associated with this order from both NSC (" + this.orderResponse.nscJobId+ ") and NSW (" + this.orderResponse.nsJobNumber+ ").", '', "success");
          }
          else if(isReject && this.orderResponse.jobId == null )
          {
            Swal.fire("Order rejected successfully.", '', "success");
          }
          else {
            
            if (orderStatusUpdateDto.status == "SentToTranscription"){
              console.log("SentToTranscription ...");
              setTimeout(() => {
              this.spinner.show();
              }, 3000);
              this.createMasterJob();
            }
            else{
              this.sendNotification("Successfully updated.", 'success');
            }
          }
        }
        this.getOrderDetails();
        // this.spinner.hide();
      },
      err => {
        console.log("error result :::", err.error.message)
        this.spinner.hide();
      })
  }
  onDateValueChanged(event: any): void {
    this.SelectedDate = event.args.date;
  }
  sendNotification(message, messageType) {
    this.msgNotification.elementRef.nativeElement.querySelector('.jqx-notification-content').innerHTML = message;
    this.msgNotification.template(messageType);
    this.msgNotification.open();
  }
  async getOrderDetails() {
    console.log("getOrderDetails starts...");
    this.isEditing = false; // Set initially
    this.orderResponse.statusHistory.forEach((element: any) => {
      if (element.isCompleted && element.notes) {
        this.textAreaValueMap[element.statusId] = element.notes;
      }
      else {
        this.textAreaValueMap[element.statusId] = "";
      }
    });

    this.orderResponse = null;
    const response = await new Promise<string>((resolve, reject) => {
      // Emit the event and expect a response from the parent
      this.notify.emit();  // Send the resolve function to the parent
    });
    this.orderResponse = response;
    this.isEditing = false;
    this.loadData();
  }
  onEditNotes(data) {
    this.isEditableValueMap[data.statusId] = true;
    this.textAreaValueMap[data.statusId] = data.notes;
  }
  async loadgetorderstatuses() {
    await this.backendService.getorderstatuses().subscribe(
      res => {
        this.orderStatusesOptions = res;
        this.spinner.hide();
      },
      err => {
        const er = this.backendService.getJSONResponse(err);
      }
    );
  }
  private convertToLocalFormat(dateString: string): string {
    // Handle the "0001-01-01T00:00:00" case which represents an invalid/default date
    if (dateString === "0001-01-01T00:00:00" || !dateString) {
      return ""; // Or string.Empty, or any other indicator for an invalid date
    }
    let date = new Date(dateString);

    // Check if the parsed date is valid
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string passed to convertToLocalFormat:', dateString);
      return "Invalid Date"; // Handle parsing errors
    }
    var formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss UTC');
    let LocalDate = new Date(formattedDate);
    return this.datePipe.transform(LocalDate, 'EEE MMMM dd yyyy HH:mm').toString() || ""; // Return the formatted date or N/A if formatting fails
  }
  sweetAlert() {
    Swal.fire({
      title: 'Confirmation',
      text: 'Do you want to reject this order?',
      allowOutsideClick: false,
      showCancelButton: true,
    }).then(async (result) => {
      console.log("result", result);
      if (result.isConfirmed && result.value) {
        this.spinner.show();
        var RejectStatus = this.orderStatusesOptions.find(item => item.status == 'Rejected');
        var orderStatusUpdateDto = new OrderStatusUpdateDto();
        orderStatusUpdateDto.statusId = RejectStatus.statusId;
        orderStatusUpdateDto.notes = this.notesComponent.val();
        orderStatusUpdateDto.statusHistoryId = 0;
        this.updateDetails(orderStatusUpdateDto, true);
      }
    });
  }
  async createMasterJob(){
      this.backendService.AllAudioFilesToMasterJob(this.orderResponse.nscJobId, "", null).pipe(
        timeout(29000), // Set the timeout limit (29 seconds)
        catchError((error) => {
          if (error.name === 'TimeoutError') {
            this.sendNotification('Files uploading to NetScribe have started and will take some time to complete.','success')
            this.spinner.hide();
          } else {
            console.error('Upload failed:', error);
            this.spinner.hide();
          }
          return throwError(error); // Propagate the error
        })
      ).subscribe(
        res => {
          console.log('File uploaded successfully:', res);
          this.spinner.hide();
        },
        err => {
          const er = this.backendService.getJSONResponse(err);
          this.spinner.hide();
        }
      );
  }
}
